import { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint, faMinusCircle } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-toastify'
import * as moment from 'moment'
import 'moment/locale/es'
import { useAppSelector } from '../../store/hooks'
import PropTypes from 'prop-types'

export default function AllMovent(props) {
  const { allMovents, name, nameproduct, quantity, measure } = props

  const componentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Reporte de Movientos en ${name} del producto: ${nameproduct}`,
    onAfterPrint: () => toast.success('Impresión exitosa'),
  })
  const { user } = useAppSelector((state) => state.init)

  const headerTitle = `Últimas Operaciones en ${name}${
    nameproduct ? ' de: ' + nameproduct : ''
  }: ${allMovents.length}`

  const renderPrices = (prices) => {
    if (!prices || prices.length === 0) {
      return (
        <FontAwesomeIcon className="h-4 text-gray-400" icon={faMinusCircle} />
      )
    }
    const formatted = prices.map(
      (p) => `${p.price.toFixed(2)} ${p.codeCurrency}`
    )
    const joined = formatted.join(', ')
    return joined
  }

  return (
    <>
      <div
        className="mx-auto max-w-full px-4 py-3 sm:px-2 sm:py-3 lg:max-w-full lg:px-8"
        ref={componentRef}
        style={{ width: '100%' }}
      >
        <div className="mx-1 flex justify-between">
          <h1 className="my-2 text-lg font-medium text-gray-900">
            {headerTitle}
          </h1>
          {measure && (
            <h1 className="my-2 text-lg font-medium text-gray-900">
              Total en existencia:{' '}
              {quantity + ' ' + (measure === 'UNIT' ? 'Unidad(s)' : measure)}
            </h1>
          )}
        </div>

        <div className="relative overflow-x-auto shadow sm:rounded-lg">
          <table className="w-full text-center text-sm text-gray-500 dark:text-gray-500">
            <thead className="bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="px-2 py-3 text-left" scope="col">
                  Codigo
                </th>
                <th className="px-2 py-3" scope="col">
                  Operación
                </th>

                <th className="px-2 py-3" scope="col">
                  Cantidad
                </th>

                <th className="px-2 py-3" scope="col">
                  Precio de Compra
                </th>
                <th className="px-2 py-3" scope="col">
                  Fecha
                </th>
                <th className="px-2 py-3" scope="col">
                  Usuario
                </th>
                <th className="px-2 py-3" scope="col">
                  Proveedor
                </th>
                <th className="px-2 py-3" scope="col">
                  Movido a
                </th>
                <th className="px-2 py-3" scope="col">
                  Nota
                </th>

                <th className="px-2 py-3" scope="col">
                  <span className="sr-only"></span>
                </th>
              </tr>
            </thead>
            <tbody>
              {allMovents &&
                allMovents.map((items, index) => (
                  <tr
                    className="border-b bg-white dark:border-gray-700 dark:bg-gray-800"
                    key={index}
                  >
                    <td className="font-sm whitespace-nowrap px-2 py-2 text-left text-gray-900 dark:text-white">
                      {items.id}
                    </td>
                    <td className="font-sm whitespace-nowrap px-2 py-2 text-gray-900 dark:text-white">
                      {items.operation === 'ENTRY' ? 'Compra' : 'Movimiento'}
                    </td>
                    <td className="font-sm whitespace-nowrap px-2 py-2 text-gray-900 dark:text-white">
                      {`${items.quantity} ${measure === 'UNIT' ? '(U)' : measure}`}
                    </td>
                    <td className="font-sm whitespace-nowrap px-2 py-2 text-gray-900 dark:text-white">
                      {renderPrices(items.prices)}
                    </td>
                    <td className="font-sm whitespace-nowrap px-2 py-2 text-gray-900 dark:text-white">
                      {moment(items.createdAt).format('L LT')}
                    </td>
                    <td className="font-sm whitespace-nowrap px-2 py-2 text-gray-900 dark:text-white">
                      {items.movedBy !== null ? (
                        items.movedBy.displayName
                      ) : (
                        <FontAwesomeIcon
                          className="h-4 text-gray-400"
                          icon={faMinusCircle}
                        />
                      )}
                    </td>
                    <td className="font-sm whitespace-nowrap px-2 py-2 text-gray-900 dark:text-white">
                      {items.supplier !== null ? (
                        items.supplier.name
                      ) : (
                        <FontAwesomeIcon
                          className="h-4 text-gray-400"
                          icon={faMinusCircle}
                        />
                      )}
                    </td>
                    <td className="font-sm whitespace-nowrap px-2 py-2 text-gray-900 dark:text-white">
                      {items.movedTo !== null ? (
                        items.movedTo.name
                      ) : (
                        <FontAwesomeIcon
                          className="h-4 text-gray-400"
                          icon={faMinusCircle}
                        />
                      )}
                    </td>
                    <td className="font-sm whitespace-pre-wrap px-2 py-2 text-gray-900 dark:text-white">
                      {items.description !== '' ? (
                        items.description
                      ) : (
                        <FontAwesomeIcon
                          className="h-4 text-gray-400"
                          icon={faMinusCircle}
                        />
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="mt-12 flex justify-between">
          <p className="overline"> {user.displayName}</p>
          <p className="">{moment().format('MMMM Do YYYY, h:mm:ss a')}</p>
        </div>
      </div>

      <button onClick={handlePrint}>
        <FontAwesomeIcon
          className="absolute left-5 top-5 h-6 text-gray-900"
          icon={faPrint}
        />
      </button>
    </>
  )
}

AllMovent.propTypes = {
  allMovents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  name: PropTypes.string.isRequired,
  nameproduct: PropTypes.string,
  quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  measure: PropTypes.string,
}
